var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.rows),function(row,i){return _c('p',{key:i,staticClass:"m-0"},[_c('span',{staticClass:"dot",style:({backgroundColor: row.color})}),_vm._v(" "+_vm._s(row.text)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }